import React, { useState } from "react";
import { Search } from "lucide-react";

function formatDate(date) {
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

export default function OutageLookup() {
  const [maKH, setMaKH] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleLookup = async () => {
    setLoading(true);
    setResult(null);
    try {
      const today = new Date();
      const next7 = new Date();
      next7.setDate(today.getDate() + 7);

      const tuNgay = formatDate(today);
      const denNgay = formatDate(next7);

      const res = await fetch(`https://lookupoutage-vbnbnaa5aq-uc.a.run.app?maKH=${maKH}`);
        const data = await res.json();
        setResult(data);
    } catch (e) {
      console.error(e);
      setResult({ error: "Có lỗi xảy ra, vui lòng thử lại." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      {/* Input + Button */}
      <div className="flex gap-2">
        <input
          type="text"
          placeholder="Nhập mã khách hàng..."
          value={maKH}
          onChange={(e) => setMaKH(e.target.value)}
          className="border px-3 py-2 rounded w-full"
        />
        <button
          onClick={handleLookup}
          disabled={!maKH || loading}
          style={{ backgroundColor: "#3F6033" }}
          className="text-white hover:opacity-90 flex items-center gap-2 px-3 py-2 rounded disabled:opacity-50 whitespace-nowrap"
        >
          <Search size={16} />
          {loading ? "Đang tra cứu..." : "Tra cứu"}
        </button>
      </div>

      {/* Kết quả */}
      {result && (
        <div className="bg-white border shadow-md rounded-lg p-4 space-y-2">
          {result.error ? (
            <p className="text-vietnam-primary">{result.error}</p>
          ) : result.hasOutage ? (
            <div className="space-y-2">
              <h3 className="font-bold text-vietnam-primary">⚠️ Có lịch cúp điện</h3>
              <p>
                <span className="font-semibold">📍 Địa điểm: </span>
                {result.location}
              </p>
              <p>
                <span className="font-semibold">⏰ Thời gian: </span>
                {result.time}
              </p>
              <p>
                <span className="font-semibold">❗ Lý do: </span>
                {result.reason}
              </p>
            </div>
          ) : (
            <div className="space-y-2">
              <h3 className="font-bold text-green-600">
                ✅ Không có lịch cúp điện
              </h3>
              <p>{result.message}</p>
              <p className="text-sm text-gray-500">{result.range}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
